import { connect } from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import AccreditationRequestsList from "./AccreditationRequestsList";
import {
    MODAL_ACCREDITATION_REQUEST_DATA,
    MODAL_REMOVE_ACCREDITATION_REQUEST,
    showModal
} from "../../../reducers/common/activeModal";
import {
    fetchGetAccreditationRequests,
    getAccreditationRequestsData, loadingAccreditationRequests
} from "../../../reducers/applicantAccreditations/accreditationRequests";
import {
    fetchAccreditationRequestById, getAccreditationRequestDataFormatted,
    onUpdateAccreditationRequest
} from "../../../reducers/applicantAccreditations/accreditationRequest";

const mapStateToProps = state => {
    return {
        loading: loadingAccreditationRequests(state),
        translation: getTranslation(state),
        data: getAccreditationRequestsData(state),
        accreditationRequest: getAccreditationRequestDataFormatted(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetAccreditationRequests())
        },
        onAccreditationRequestRemove: () => dispatch(showModal({modalKey: MODAL_REMOVE_ACCREDITATION_REQUEST})),
        onUpdate: (id, data) => {
            dispatch(onUpdateAccreditationRequest(id, data, false));
        },
        onGetAccreditationRequestData: (id) => {
            dispatch(fetchAccreditationRequestById(id))
        },
        onShowAccreditationRequestModal: () => {
            dispatch(showModal({modalKey: MODAL_ACCREDITATION_REQUEST_DATA}))
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(AccreditationRequestsList);



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/accreditationRequestsList/AccreditationRequestsList.conatiner.js